import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import Stack from "@mui/material/Stack";

const DIALOG_Z_INDEX = 3000;

const FlowBuilderCloseTicketModal = ({ open, onSave, onUpdate, data, close }) => {
  const [activeModal, setActiveModal] = useState(false);
  const [sendFarewellMessage, setSendFarewellMessage] = useState(true);
  const [customFarewellMessage, setCustomFarewellMessage] = useState("");

  useEffect(() => {
    if (open === "edit" || open === "create") {
      const d = open === "edit" ? data?.data : {};
      setSendFarewellMessage(d?.sendFarewellMessage !== false);
      setCustomFarewellMessage(d?.customFarewellMessage || "");
      setActiveModal(true);
    } else {
      setActiveModal(false);
    }
  }, [open, data]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const buildPayload = () => ({
    sendFarewellMessage,
    customFarewellMessage: customFarewellMessage.trim(),
  });

  const handleSave = () => {
    const payload = buildPayload();
    handleClose();
    if (open === "edit") {
      onUpdate({ ...data, data: payload });
    } else {
      onSave(payload);
    }
  };

  return (
    <Dialog
      open={activeModal}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      style={{ zIndex: DIALOG_Z_INDEX }}
      PaperProps={{ style: { zIndex: DIALOG_Z_INDEX, position: "relative" } }}
      BackdropProps={{
        style: { zIndex: DIALOG_Z_INDEX - 1, backgroundColor: "rgba(0, 0, 0, 0.5)" },
      }}
    >
      <DialogTitle>
        {open === "edit" ? "Editar Fechar Ticket" : "Adicionar Fechar Ticket"}
      </DialogTitle>
      <Stack spacing={2} sx={{ px: 2, pb: 2 }}>
        <Typography variant="body2" color="textSecondary">
          Encerra o ticket do contato ao executar este bloco no fluxo.
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={sendFarewellMessage}
              onChange={(e) => setSendFarewellMessage(e.target.checked)}
            />
          }
          label="Enviar mensagem de despedida"
        />
        <TextField
          label="Mensagem personalizada (opcional)"
          placeholder="Deixe vazio para usar a mensagem de conclusão da conexão"
          value={customFarewellMessage}
          onChange={(e) => setCustomFarewellMessage(e.target.value)}
          multiline
          minRows={3}
          variant="outlined"
          fullWidth
          disabled={!sendFarewellMessage}
        />
      </Stack>
      <DialogActions>
        <Button onClick={handleClose} color="secondary" variant="outlined">
          Cancelar
        </Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderCloseTicketModal;
